import { render } from "./BlockSocioDadosComplementares.vue?vue&type=template&id=53702024"
import script from "./BlockSocioDadosComplementares.vue?vue&type=script&lang=js"
export * from "./BlockSocioDadosComplementares.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockSocioDadosComplementares.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53702024"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53702024', __exports__)) {
    console.log('reload')
    api.reload('53702024', __exports__)
  }
  
  module.hot.accept("./BlockSocioDadosComplementares.vue?vue&type=template&id=53702024", () => {
    console.log('re-render')
    api.rerender('53702024', render)
  })

}


export default __exports__